import { Vector2, Color, RepeatWrapping } from 'three'

export const updateMaterialFromJSON = async (
  model,
  material,
  materialData = {},
  loadedTextures = {},
) => {
  // defaults
  const {
    color: baseColor = '#ffffff',
    roughness: baseRoughness = 1.0,
    normalScale: baseNormalScale = 1.0,
    metalness: baseMetalness = 0.0,
    transparent: transparentFlag = 0,
    sheen: baseSheen = 0.0,
    sheenColor: baseSheenColor = '#000000',
    sheenRoughness: baseSheenRoughness = 1.0,
    thickness: baseThickness = 0.0,
    transmission: baseTransmission = 0.0,
  } = materialData

  const {
    colorMap = null,
    roughnessMap = null,
    normalMap = null,
    opacityMap = null,
    // displacementMap = null,
  } = loadedTextures

  console.log(materialData)

  // color map, indien aanwezig, material = wit
  const color = new Color()
  material.color = colorMap ? color.set('white') : color.set(baseColor)
  material.map = colorMap

  // roughness
  material.roughness = roughnessMap ? 1.0 : baseRoughness
  material.roughnessMap = roughnessMap

  // normal
  material.normalMap = normalMap

  if (
    materialData?.color_identifier &&
    materialData.color_identifier.endsWith('DM')
  ) {
    material.normalScale.set(2, 2)
  } else {
    material.normalScale.set(1, 1)
  }

  // displacement
  // material.displacementMap = displacementMap
  // material.displacementScale = 0

  // metalness / transmission / thickness
  material.metalness = baseMetalness
  material.transmission = baseTransmission
  material.thickness = baseThickness

  // transparency
  material.alphaMap = opacityMap ?? null
  material.transparent = transparentFlag === 1 || transparentFlag === true

  // sheen
  material.sheen = baseSheen
  material.sheenColor = new Color().set(baseSheenColor)
  material.sheenRoughness = baseSheenRoughness

  // uv scale van 10 voor mid
  let custom_uv_scale_x = false
  let custom_uv_scale_y = false

  if (materialData.code === 'mid') {
    custom_uv_scale_x = custom_uv_scale_y = 10
  }

  if (materialData.code === 'int') {
    custom_uv_scale_x = 4.7899
    custom_uv_scale_y = 5.5258
  }

  if (materialData.code === 'ext') {
    custom_uv_scale_x = 7.72559
    custom_uv_scale_y = 10.2329
  }

  if (custom_uv_scale_x && custom_uv_scale_x) {
    for (const tex of [
      colorMap,
      roughnessMap,
      normalMap,
      opacityMap,
      // displacementMap,
    ]) {
      if (!tex) continue

      tex.wrapS = tex.wrapT = RepeatWrapping
      tex.repeat.set(custom_uv_scale_x, custom_uv_scale_y)

      tex.needsUpdate = true
    }
  }

  // three.js vragen om te hercompileren
  material.needsUpdate = true

  // testcode om naar een rubber mesh to zoeken
  // if (
  //   model &&
  //   materialData?.attribute &&
  //   materialData?.color &&
  //   materialData.attribute === 'frame_material_colour'
  // ) {
  //   model?.traverse((child) => {
  //     if (
  //       child.isMesh &&
  //       child?.material &&
  //       child.name === `${model.name}_rubber`
  //     ) {
  //       // mesh gevonden voor frame_material_colour en een overeenkomstige rubber mesh
  //       child.material.color = new Color().set(materialData.color)
  //       child.material.needsUpdate = true
  //       console.log(
  //         `🖌️ rubber feet found for ${materialData.attribute}, color applied: ${materialData.color}`,
  //       )
  //     }
  //   })
  // }
}

export const applyMaterial = async (
  model,
  material,
  materialData,
  textures,
  onError,
  onDone,
) => {
  try {
    await updateMaterialFromJSON(model, material, materialData, textures)
    onDone?.()
  } catch (error) {
    console.error('❌ Error applying material:', error)
    onError?.(error)
  }
}
